/**
 * EditorialMarquee - one slow, editorial strip between the cinematic and services.
 */
const ITEMS = ["Websites", "Software", "Systems", "Support"];

function Row({ ariaHidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {ITEMS.map((item, i) => (
        <span key={item} className="flex items-center">
          <span
            className={`font-display font-bold uppercase tracking-tight text-[clamp(2.2rem,5vw,4.6rem)] leading-none px-6 md:px-10 ${
              i % 2 === 1
                ? "text-transparent [-webkit-text-stroke:1.5px_rgba(26,26,26,0.35)]"
                : "text-[color:var(--ww-charcoal)]"
            }`}
          >
            {item}
          </span>
          <svg viewBox="0 0 24 24" className="w-5 h-5 md:w-7 md:h-7 text-emerald-500">
            <path
              d="M12 2 L14.5 9.5 L22 12 L14.5 14.5 L12 22 L9.5 14.5 L2 12 L9.5 9.5 Z"
              fill="currentColor"
            />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-black/10 bg-[color:var(--ww-cream)] py-8 md:py-10"
    >
      <div
        className="flex w-max marquee-track"
        style={{ animationDuration: "48s" }}
      >
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
